// @flow
import NewsletterCategory from 'components/newsletter/NewsletterCategory';
import { connect } from 'react-redux';

import { fetchArticlesCategory } from 'actions/newsletterCategoryActions';
import { fetchArticlesStaticCategories } from 'actions/newsletterActions';
import { fetchGenericSidebar } from 'actions/sidebarActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/newsletter/NewsletterCategory';

export default connect(
  (state: StateType, ownProps): StateProps => ({
    status: state.newsletterCategoryState.status,
    articleNumber: state.newsletterCategoryState.articleNumber,
    articles: state.newsletterCategoryState.articles,
    categories: state.categoriesState.categories,
    categoriesArticle: state.newsletterState.categoriesArticle,
    sidebar: state.sidebarState,
    ligue: state.settingsState.ligue,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticlesCategory: (page: number, per_page: number, category: string) =>
      dispatch(fetchArticlesCategory(page, per_page, category)),
    fetchArticlesStaticCategories: () => dispatch(fetchArticlesStaticCategories()),
    fetchGenericSidebar: () => dispatch(fetchGenericSidebar()),
  })
)(NewsletterCategory);
